<template>
    <div class="">
        <h1>{{ $t('labels.enter_row_status') }}</h1>

        <div class="actions actions--fixed">
            <div class="action action--wide" v-for="status in statuses" :key="status.value">
                <a href="#" :class="getButtonClasses(status)" @click.prevent="setRowStatus(status.value)">
                    <span>{{ status.title }}</span>
                </a>
            </div>
        </div>

        <div class="app-actions">
            <cancel-button :redirect="cancelRedirect()"></cancel-button>
        </div>
    </div>
</template>

<script>
    import CancelButton from "../components/app/CancelButton";
    import {writeTrackLog} from "../utils/tracking";

    export default {
        name: 'row-status',

        components: {CancelButton},

        data () {
            return {
                statuses: [
                    { title: this.$t('statuses.row.finished'), value: 'finished' },
                    { title: this.$t('statuses.row.not_finished'), value: 'not_finished' },
                    { title: this.$t('statuses.row.finished_pending'), value: 'finished_pending' }
                ].filter((status) => {
                  const device = this.$store.state.currentDevice;
                  return !device.statuses || !device.statuses.length || device.statuses.includes(status.value)
                })
            }
        },

		computed: {
			currentDevice () {
				return this.$store.state.currentDevice;
			},

			currentActivity () {
				return this.$store.getters.currentActivityForEmployee
			}
		},

        methods: {
            getButtonClasses(status) {
                return {
					'action-button': true,
                    'active': this.currentActivity && this.currentActivity.row_status && this.currentActivity.row_status === status.value
                };
            },

			cancelRedirect () {
				if (this.$store.state.enableTracking) writeTrackLog("Cancel from: " + this.$route.name);

				if (this.currentActivity) {
					const activity = this.$store.getters.activityById(this.currentActivity.activity_id);

					if (this.currentDevice.pre_register_activities) {
						if (activity.register_row_numbers) return {name: 'row'};
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    } else {
						if (activity.register_row_numbers) return {name: 'row'};
						if (activity.register_amounts) return {name: 'amount'};
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    }
				}

				return {name: 'activity'};
			},

            setRowStatus (status) {
				if (this.$store.state.enableTracking) writeTrackLog("Set row status: " + status);

              const oldEntry = this.currentActivity;
                oldEntry.row_status = status;

              const activity = this.$store.getters.activityById(oldEntry.activity_id);
                if (activity.register_row_numbers && status === 'finished') {
                  if (this.$store.state.enableTracking) writeTrackLog("Set row percentage: 100 because row status is finished" );

                  oldEntry.row_percentage = 100;
                }

                this.$store.dispatch('updateActivity', {
                    id: oldEntry.id,
                    'row_status': status
                });

                const route = this.$parent.determineRoute(oldEntry);

                if (route !== null && route !== undefined) return this.$router.push(route)
            }
        },

        mounted () {
            window.events.$emit('disableNumpad');
        },

        beforeDestroy () {
            window.events.$emit('enableNumpad');
        }
    }
</script>
